import { render, staticRenderFns } from "./AsiMenuItem.vue?vue&type=template&id=4fbea2e4&scoped=true"
import script from "./AsiMenuItem.vue?vue&type=script&lang=ts"
export * from "./AsiMenuItem.vue?vue&type=script&lang=ts"
import style0 from "./AsiMenuItem.vue?vue&type=style&index=0&id=4fbea2e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbea2e4",
  null
  
)

export default component.exports